module.exports = __webpack_public_path__ + "media/images/logo-account-7e4b57b0770b7a238c4f6751ec4f58ef.svg";